import TokenStore from "./token-store";
import Auth from "./auth";
import config from '../config'

const tokenStore = new TokenStore();
const auth = new Auth(tokenStore, config);

export default auth;
